// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.archive {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.archive > h1, .archive > div > h1 {
  color: #777f87;
  font-size: 24px;
  font-weight: 600;
}
.managers-list
{
  margin: 15px 0;
}

.archive__container {
  width: 100%;
  overflow: hidden;
  overflow: auto;
}

.archive__list {
  min-width: 1024px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* .archive__item:hover {
  background: #fff;
  border: 1px solid #dde1eb;
} */

.archive__list > :nth-child(odd) {
  background: transparent;
  border: 1px solid #dde1eb;
}

.archive__list > li {
  width: 100%;
  height: 65px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.archive__header {
  width: 100%;
  display: flex;
  align-items: center;
  background: #fff;
  z-index: 99;
  border: 1px solid transparent !important;
}

.archive__header > p {
  height: 30px;
  border-right: 1px solid #b2bac6;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b2bac6;
  font-size: 10px;
  font-weight: 500;
}

.archive__header > p:last-child {
  border-right: none;
}

.archive__item {
  width: 100%;
  display: flex;
  align-items: center;
  background: #dde1eb;
  border: 1px solid transparent;
}

.archive__item > p {
  border-right: 1px solid #b2bac6;
  color: #424242;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 10px;
  text-overflow: ellipsis;
  text-align: center;
}

.archive__list .w60 {
  width: 60px !important;
}

.archive__list .w75 {
  width: 75px !important;
}

.archive__list .w170 {
  width: 170px !important;
}

.archive__list .w150 {
  width: 150px !important;
}

.archive__list .w140 {
  width: 140px !important;
}

.archive__list .w155 {
  width: 155px !important;
}

.archive__list .w90 {
  width: 90px !important;
}

.archive__list .w50 {
  width: 50px !important;
}
.archive__list .w55 {
  width: 55px !important;
}

.archive__list label {
  padding: 0 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.archive__list label > svg {
  font-size: 20px;
  color: #0c6b60;
}

.archive__list label > :nth-child(2) {
  display: none;
}

.archive__list label > input:checked + :nth-child(2) {
  display: flex;
}

.archive__list label > input:checked ~ :nth-child(3) {
  display: none;
}

.archive__item > .w170 {
  justify-content: flex-start;
}

.archive__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 10px;
  gap: 8px;
  flex: 1 1;
}

.archive__actions > button, .archive__actions > a > button {
  height: 34px;
  padding: 0 20px;
  border: 1px solid #b2bac6;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;

  color: #0c6b60;
  font-size: 10px;
  font-weight: 500;
  stroke-width: 1px;
}

.archive__actions > .delete {
  border-color: #e0383d;
  color: #e0383d;
  text-align: center;
  font-weight: 500;
}

.no_button
{
  background: unset;
  padding: 0;
  margin: 0;
  cursor: pointer;
      border: none;
}

.type_list_user
{
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 10px;
}

.type_list_user .image img 
{
  max-width: 55px;
}

.type_list_user .role
{
    font-size: 12px;
    background: #878484;
    padding: 5px;
    border-radius: 5px;
    color: #fff;
}

.type_list_user button 
{
    height: 34px;
    padding: 0 20px;
    border: 1px solid #b2bac6;
    border-radius: 8px;
    background: transparent;
    cursor: pointer;
    color: #0c6b60;
    font-size: 10px;
    font-weight: 500;
    stroke-width: 1px;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/user/archive.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;GAGG;;AAEH;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;;EAEf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,eAAe;MACX,YAAY;AAClB;;AAEA;;IAEI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;AACb;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;IAEI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".archive {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.archive > h1, .archive > div > h1 {\n  color: #777f87;\n  font-size: 24px;\n  font-weight: 600;\n}\n.managers-list\n{\n  margin: 15px 0;\n}\n\n.archive__container {\n  width: 100%;\n  overflow: hidden;\n  overflow: auto;\n}\n\n.archive__list {\n  min-width: 1024px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* .archive__item:hover {\n  background: #fff;\n  border: 1px solid #dde1eb;\n} */\n\n.archive__list > :nth-child(odd) {\n  background: transparent;\n  border: 1px solid #dde1eb;\n}\n\n.archive__list > li {\n  width: 100%;\n  height: 65px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.archive__header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  background: #fff;\n  z-index: 99;\n  border: 1px solid transparent !important;\n}\n\n.archive__header > p {\n  height: 30px;\n  border-right: 1px solid #b2bac6;\n  padding: 0 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #b2bac6;\n  font-size: 10px;\n  font-weight: 500;\n}\n\n.archive__header > p:last-child {\n  border-right: none;\n}\n\n.archive__item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  background: #dde1eb;\n  border: 1px solid transparent;\n}\n\n.archive__item > p {\n  border-right: 1px solid #b2bac6;\n  color: #424242;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 8px 10px;\n  text-overflow: ellipsis;\n  text-align: center;\n}\n\n.archive__list .w60 {\n  width: 60px !important;\n}\n\n.archive__list .w75 {\n  width: 75px !important;\n}\n\n.archive__list .w170 {\n  width: 170px !important;\n}\n\n.archive__list .w150 {\n  width: 150px !important;\n}\n\n.archive__list .w140 {\n  width: 140px !important;\n}\n\n.archive__list .w155 {\n  width: 155px !important;\n}\n\n.archive__list .w90 {\n  width: 90px !important;\n}\n\n.archive__list .w50 {\n  width: 50px !important;\n}\n.archive__list .w55 {\n  width: 55px !important;\n}\n\n.archive__list label {\n  padding: 0 10px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.archive__list label > svg {\n  font-size: 20px;\n  color: #0c6b60;\n}\n\n.archive__list label > :nth-child(2) {\n  display: none;\n}\n\n.archive__list label > input:checked + :nth-child(2) {\n  display: flex;\n}\n\n.archive__list label > input:checked ~ :nth-child(3) {\n  display: none;\n}\n\n.archive__item > .w170 {\n  justify-content: flex-start;\n}\n\n.archive__actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0 10px;\n  gap: 8px;\n  flex: 1;\n}\n\n.archive__actions > button, .archive__actions > a > button {\n  height: 34px;\n  padding: 0 20px;\n  border: 1px solid #b2bac6;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n\n  color: #0c6b60;\n  font-size: 10px;\n  font-weight: 500;\n  stroke-width: 1px;\n}\n\n.archive__actions > .delete {\n  border-color: #e0383d;\n  color: #e0383d;\n  text-align: center;\n  font-weight: 500;\n}\n\n.no_button\n{\n  background: unset;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n      border: none;\n}\n\n.type_list_user\n{\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    gap: 10px;\n}\n\n.type_list_user .image img \n{\n  max-width: 55px;\n}\n\n.type_list_user .role\n{\n    font-size: 12px;\n    background: #878484;\n    padding: 5px;\n    border-radius: 5px;\n    color: #fff;\n}\n\n.type_list_user button \n{\n    height: 34px;\n    padding: 0 20px;\n    border: 1px solid #b2bac6;\n    border-radius: 8px;\n    background: transparent;\n    cursor: pointer;\n    color: #0c6b60;\n    font-size: 10px;\n    font-weight: 500;\n    stroke-width: 1px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
